import { IBaseModalProps } from "core/types/elements/IModal";
import React, { FC, useEffect, useRef } from "react";
import BaseModal from "components/common/BaseModal/BaseModal";

interface IProps extends IBaseModalProps<string> {
  modalBody?: React.ReactNode;
}

const WarningModal: FC<IProps> = ({
  onClose,
  onCancel,
  onSave,
  showModal,
  modalTitle,
  modalBody,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (showModal && modalRef.current) {
      // Increase z-index to ensure warning modal appears above parent modal
      const modalElement = modalRef.current.closest(".modal");
      if (modalElement) {
        (modalElement as HTMLElement).style.zIndex = "1060";
      }
    }
  }, [showModal]);

  const handleSave = () => {
    if (onSave) {
      onSave();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div ref={modalRef}>
      <BaseModal
        modalTitle={modalTitle}
        onClose={handleClose}
        onCancel={handleCancel}
        showModal={showModal}
        onSave={handleSave}
        cancelActionBtnText="No"
        successBtnText="Yes"
        modalBody={modalBody}
        modalClass="modal-sm"
        disableCloseActions
      />
    </div>
  );
};

export default WarningModal;
